"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ProductUtilities_1 = require("../ProductUtilities");
/**
 * Returns all loans from the set of products, cast into the proper type
 * @param products a collection of products, can include loans and credit cards
 * @returns the subset of input products that are loans
 */
exports.loansFromProducts = (products) => ProductUtilities_1.destructure(products)
    .filter((product) => product.__typename === 'Loan');
/**
 * Checks whether the input loan is in an `endOfLife` state
 * @param param0 unnamed parameter that is an object that implements the `IEndOfLifeLoan` interface
 * @returns whether or not the input loan is in `endOfLife` state
 */
exports.isEndOfLifeLoan = ({ isSoldOff, isBankruptcyDischarged, isChargedOff, isPaidOff }) => isSoldOff || isBankruptcyDischarged || isChargedOff || isPaidOff;
/**
 * Checks if the input loan is disqualifed from quote payoff
 * @param loan is a loan with the necessary information to establish payoff eligibility
 * @returns the input loans eligibility for payoff
 * If `payoffInformation` or `payoffQuoteDisqualified` is `null`, return `false`.
 */
exports.payoffQuoteDisqualified = (loan) => loan.payoffInformation !== null && loan.payoffInformation.payoffQuoteDisqualified;
/**
 * Fetches the scheduled quote for the input loan
 * @param loan is a loan with the necessary information to verify whether it has a scheduled quote payoff
 * @returns the scheduled quote payoff for the input loan, if the quote payoff exists
 */
exports.scheduledQuoteForLoan = (loan) => loan.payoffInformation && loan.payoffInformation.scheduledQuote;
/**
 * Checks if a set of products includes a loan with a scheduled quote
 * @param products is a list of products of either loans that implement `IPayoffLoan` or credit cards
 * @returns `true` if any of the input list of products contains a scheduled quote payoff, `false` otherwise
 */
exports.productsContainScheduledQuote = (products) => exports.loansFromProducts(products)
    .some(loan => !!exports.scheduledQuoteForLoan(loan));
/**
 * Returns the subset of loans that are currently active
 * @param products is a list of products that are either loans that implement `IStatusLoan` or credit cards
 * @returns a list of loans that are active products
 */
exports.activeLoans = (products) => exports.loansFromProducts(products)
    .filter(loan => ['current', 'late'].includes(loan.status));
/**
 * Checks if the input product is a loan
 * @param product is either a loan or a credit card product
 * @returns the input product cast into type `Loan`, if input product is a loan
 */
exports.isLoan = (product) => (product.__typename === 'Loan');
/**
 * Returns all the loans that have contracts
 * @param products list of products that are either loans that implement `ILoanWithContract` or credit cards
 * @returns a subset of loans from the input products that have valid contracts to display
 */
exports.loansWithContracts = (products) => exports.loansFromProducts(products)
    .filter((product) => product.contracts && product.contracts.edges.length > 0);
/**
 * Returns the contract from the input loan
 * @param product is product that is either a credit card, or a loan that implements `ILoanWithContract`
 * @returns the products contract as a string if the product is a loan and has a contract
 */
exports.contractFromLoan = (product) => exports.isLoan(product) && product.contracts.edges.length > 0 ? ProductUtilities_1.destructure(product.contracts)[0].contract : null;
